module.exports = __webpack_public_path__ + "static/media/termopary1kz.10f36a1f.pdf";